import Api from './ApiService'

export default {
    get(keyword, pageNumber, filters, order) {
        const params = new URLSearchParams();

        params.append('keyword', keyword);
        params.append('pageNumber', pageNumber);
        params.append('orderColumn', order.column);
        params.append('orderSort', order.sort);

        // Serializando os filtros
        Object.keys(filters).forEach(key => {
            filters[key].forEach(value => {
                params.append(`${key}[]`, value);
            });
        });

        return Api().get(`ailogs`, { params });
    },
    export(keyword, filters, order) {
        const params = new URLSearchParams();
        params.append('keyword', keyword);
        params.append('export', true);
        params.append('orderColumn', order.column);
        params.append('orderSort', order.sort);

        // Serializando os filtros
        Object.keys(filters).forEach(key => {
            filters[key].forEach(value => {
                params.append(`${key}[]`, value);
            });
        });

        return Api().get('ailogs', {
            params,
            responseType: 'blob'
        });
    },
    getOne(id) {
        return Api().get(`ailogs/${id}`);
    },
    rollback(id) {
        return Api().post(`ailogs/rollback/${id}`);
    }
}